// extracted by mini-css-extract-plugin
export var active = "Anchor-module--active--a5d58";
export var anchorHeader = "Anchor-module--anchor-header--ea3bb";
export var anchorHeaderContainer = "Anchor-module--anchor-header-container--8d3a7";
export var fixed = "Anchor-module--fixed--a28db";